import * as React from "react";

import primaryColour from "../../constants";

function SvgRop(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.06585 18.9759C2.78847 15.6985 2.78847 10.3848 6.06585 7.10744L4.93447 5.97607C1.03226 9.87829 1.03226 16.205 4.93447 20.1072L6.06585 18.9759Z"
        fill={fill}
      />
      <path
        d="M17.9342 18.9759C21.2116 15.6985 21.2116 10.3848 17.9342 7.10744L19.0656 5.97607C22.9678 9.87829 22.9678 16.205 19.0656 20.1072L17.9342 18.9759Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.86147 11.301C5.58533 10.8227 5.74921 10.2112 6.2275 9.93501L12.3543 6.3977C12.8326 6.12156 13.4442 6.28544 13.7203 6.76373L15.1635 9.26336L15.1681 9.27149L18.2057 14.5326C18.3438 14.7718 18.2618 15.0776 18.0227 15.2156L17.6797 15.4137C17.4405 15.5518 17.1347 15.4698 16.9967 15.2307L16.1996 13.8502L10.7589 16.9914L11.5559 18.3719C11.694 18.6111 11.612 18.9168 11.3729 19.0549L11.0299 19.253C10.7907 19.391 10.4849 19.3091 10.3469 19.07L5.86147 11.301ZM6.7275 10.801L12.8543 7.26373L14.0995 9.42043L7.97267 12.9577L6.7275 10.801ZM10.4097 16.3869C10.7436 16.1941 10.858 15.7672 10.6652 15.4333C10.4725 15.0995 10.0456 14.9851 9.71169 15.1778C9.37782 15.3706 9.26343 15.7975 9.45619 16.1314C9.64895 16.4653 10.0759 16.5797 10.4097 16.3869ZM16.106 12.2921C16.2988 12.6259 16.1844 13.0529 15.8505 13.2456C15.5166 13.4384 15.0897 13.324 14.897 12.9901C14.7042 12.6563 14.8186 12.2293 15.1525 12.0366C15.4863 11.8438 15.9133 11.9582 16.106 12.2921Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgRop;
